"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return BarcodeColumn;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _index = require("~/models/index");
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let BarcodeColumn = class BarcodeColumn {
    static async insert(context, barcodeColumn, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(barcodeColumn, [
            'fk_column_id',
            'fk_barcode_value_column_id',
            'barcode_format'
        ]);
        const column = await _index.Column.get(context, {
            colId: insertObj.fk_column_id
        }, ncMeta);
        if (!column) {
            _catchError.NcError.fieldNotFound(insertObj.fk_column_id);
        }
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.COL_BARCODE, insertObj);
        return this.read(context, barcodeColumn.fk_column_id, ncMeta);
    }
    static async read(context, columnId, ncMeta = _Noco.default.ncMeta) {
        let column = columnId && await _NocoCache.default.get(context, `${_globals.CacheScope.COL_BARCODE}:${columnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!column) {
            column = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COL_BARCODE, {
                fk_column_id: columnId
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.COL_BARCODE}:${columnId}`, column);
        }
        return column ? new BarcodeColumn(column) : null;
    }
    async getValueColumn(context, ncMeta = _Noco.default.ncMeta) {
        return _index.Column.get(context, {
            colId: this.fk_barcode_value_column_id
        }, ncMeta);
    }
    constructor(data){
        Object.assign(this, data);
    }
};
